import accordion from '@primeng/themes/nora/accordion';
import autocomplete from '@primeng/themes/nora/autocomplete';
import avatar from '@primeng/themes/nora/avatar';
import badge from '@primeng/themes/nora/badge';
import base from '@primeng/themes/nora/base';
import blockui from '@primeng/themes/nora/blockui';
import breadcrumb from '@primeng/themes/nora/breadcrumb';
import button from '@primeng/themes/nora/button';
import card from '@primeng/themes/nora/card';
import carousel from '@primeng/themes/nora/carousel';
import cascadeselect from '@primeng/themes/nora/cascadeselect';
import checkbox from '@primeng/themes/nora/checkbox';
import chip from '@primeng/themes/nora/chip';
import colorpicker from '@primeng/themes/nora/colorpicker';
import confirmdialog from '@primeng/themes/nora/confirmdialog';
import confirmpopup from '@primeng/themes/nora/confirmpopup';
import contextmenu from '@primeng/themes/nora/contextmenu';
import datatable from '@primeng/themes/nora/datatable';
import dataview from '@primeng/themes/nora/dataview';
import datepicker from '@primeng/themes/nora/datepicker';
import dialog from '@primeng/themes/nora/dialog';
import divider from '@primeng/themes/nora/divider';
import dock from '@primeng/themes/nora/dock';
import drawer from '@primeng/themes/nora/drawer';
import editor from '@primeng/themes/nora/editor';
import fieldset from '@primeng/themes/nora/fieldset';
import fileupload from '@primeng/themes/nora/fileupload';
import floatlabel from '@primeng/themes/nora/floatlabel';
import galleria from '@primeng/themes/nora/galleria';
import iconfield from '@primeng/themes/nora/iconfield';
import iftalabel from '@primeng/themes/nora/iftalabel';
import image from '@primeng/themes/nora/image';
import imagecompare from '@primeng/themes/nora/imagecompare';
import inlinemessage from '@primeng/themes/nora/inlinemessage';
import inplace from '@primeng/themes/nora/inplace';
import inputchips from '@primeng/themes/nora/inputchips';
import inputgroup from '@primeng/themes/nora/inputgroup';
import inputnumber from '@primeng/themes/nora/inputnumber';
import inputotp from '@primeng/themes/nora/inputotp';
import inputtext from '@primeng/themes/nora/inputtext';
import knob from '@primeng/themes/nora/knob';
import listbox from '@primeng/themes/nora/listbox';
import megamenu from '@primeng/themes/nora/megamenu';
import menu from '@primeng/themes/nora/menu';
import menubar from '@primeng/themes/nora/menubar';
import message from '@primeng/themes/nora/message';
import metergroup from '@primeng/themes/nora/metergroup';
import multiselect from '@primeng/themes/nora/multiselect';
import orderlist from '@primeng/themes/nora/orderlist';
import organizationchart from '@primeng/themes/nora/organizationchart';
import overlaybadge from '@primeng/themes/nora/overlaybadge';
import paginator from '@primeng/themes/nora/paginator';
import panel from '@primeng/themes/nora/panel';
import panelmenu from '@primeng/themes/nora/panelmenu';
import password from '@primeng/themes/nora/password';
import picklist from '@primeng/themes/nora/picklist';
import popover from '@primeng/themes/nora/popover';
import progressbar from '@primeng/themes/nora/progressbar';
import progressspinner from '@primeng/themes/nora/progressspinner';
import radiobutton from '@primeng/themes/nora/radiobutton';
import rating from '@primeng/themes/nora/rating';
import ripple from '@primeng/themes/nora/ripple';
import scrollpanel from '@primeng/themes/nora/scrollpanel';
import select from '@primeng/themes/nora/select';
import selectbutton from '@primeng/themes/nora/selectbutton';
import skeleton from '@primeng/themes/nora/skeleton';
import slider from '@primeng/themes/nora/slider';
import speeddial from '@primeng/themes/nora/speeddial';
import splitbutton from '@primeng/themes/nora/splitbutton';
import splitter from '@primeng/themes/nora/splitter';
import stepper from '@primeng/themes/nora/stepper';
import steps from '@primeng/themes/nora/steps';
import tabmenu from '@primeng/themes/nora/tabmenu';
import tabs from '@primeng/themes/nora/tabs';
import tabview from '@primeng/themes/nora/tabview';
import tag from '@primeng/themes/nora/tag';
import terminal from '@primeng/themes/nora/terminal';
import textarea from '@primeng/themes/nora/textarea';
import tieredmenu from '@primeng/themes/nora/tieredmenu';
import timeline from '@primeng/themes/nora/timeline';
import toast from '@primeng/themes/nora/toast';
import togglebutton from '@primeng/themes/nora/togglebutton';
import toggleswitch from '@primeng/themes/nora/toggleswitch';
import toolbar from '@primeng/themes/nora/toolbar';
import tooltip from '@primeng/themes/nora/tooltip';
import tree from '@primeng/themes/nora/tree';
import treeselect from '@primeng/themes/nora/treeselect';
import treetable from '@primeng/themes/nora/treetable';
import virtualscroller from '@primeng/themes/nora/virtualscroller';
import type { NoraBaseDesignTokens } from '@primeuix/themes/nora/base';
import type { Preset } from '@primeuix/themes/types';

export default {
    ...base,
    components: {
        accordion,
        autocomplete,
        avatar,
        badge,
        blockui,
        breadcrumb,
        button,
        datepicker,
        card,
        carousel,
        cascadeselect,
        checkbox,
        chip,
        colorpicker,
        confirmdialog,
        confirmpopup,
        contextmenu,
        dataview,
        datatable,
        dialog,
        divider,
        dock,
        drawer,
        editor,
        fieldset,
        fileupload,
        iftalabel,
        floatlabel,
        galleria,
        iconfield,
        image,
        imagecompare,
        inlinemessage,
        inplace,
        inputchips,
        inputgroup,
        inputnumber,
        inputotp,
        inputtext,
        knob,
        listbox,
        megamenu,
        menu,
        menubar,
        message,
        metergroup,
        multiselect,
        orderlist,
        organizationchart,
        overlaybadge,
        popover,
        paginator,
        password,
        panel,
        panelmenu,
        picklist,
        progressbar,
        progressspinner,
        radiobutton,
        rating,
        ripple,
        scrollpanel,
        select,
        selectbutton,
        skeleton,
        slider,
        speeddial,
        splitter,
        splitbutton,
        stepper,
        steps,
        tabmenu,
        tabs,
        tabview,
        textarea,
        tieredmenu,
        tag,
        terminal,
        timeline,
        togglebutton,
        toggleswitch,
        tree,
        treeselect,
        treetable,
        toast,
        toolbar,
        tooltip,
        virtualscroller
    }
} as Preset<NoraBaseDesignTokens>;
